module.exports = __webpack_public_path__ + "static/media/icon-play.f7bcca49.svg";